export default "__VITE_ASSET__DqFW$Ty2__"